module.exports = __webpack_public_path__ + "sv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sv.svg
// module id = 821
// module chunks = 0